
export default class Main{

    constructor(){
        this._init();
        this._ui();
    }


    _init(){
        this.$storybox = document.querySelector(`.storybox.-story1`);

        this.$thumblist_inner = document.querySelector('.js-thumlist__inner');
        this.thumblist_items = [...document.querySelectorAll('.thumblist__item')];

        this.current = 'story1';
        this.season = 'season1';
        this.title = '';
    }


    _ui(){

        this.thumblist_items.forEach($thumb=>{

            $thumb.addEventListener('click', ()=>{
                const key = $thumb.getAttribute('data-key');
                const season = $thumb.getAttribute('data-season');
                const title = $thumb.getAttribute('data-title');
                this._change(key, season, title);
            });

            $thumb.addEventListener('mouseover', (e)=>{
                if(window.innerWidth < 769) return;
                const season = $thumb.getAttribute('data-season');
                if(season != this.season) document.body.setAttribute('data-season', season);
            });

            $thumb.addEventListener('mouseout', (e)=>{
                if(window.innerWidth < 769) return;
                const season = $thumb.getAttribute('data-season');
                if(season != this.season) document.body.setAttribute('data-season', this.season);
            });
        });

        const $story1 = document.querySelector(`.storybox.-story1`);
        $story1.querySelector('.storybox__season__sholder').classList.add('-change');
        $story1.querySelector('.storybox__season__title').classList.add('-change');


        this.$thumblist_inner.addEventListener('scroll', () => {
            if(window.innerWidth >= 769) return;

            let mostLeftLi = null; 
            let mostLeftLiPosition = Infinity; 

            this.thumblist_items.forEach($li=>{
                const rect = $li.getBoundingClientRect();

                if(rect.left >= 0 && rect.right > 0) {

                    if(rect.left < mostLeftLiPosition) {
                        mostLeftLiPosition = rect.left;
                        mostLeftLi = $li;
                    }
                }

                if(mostLeftLi) {
                    const season = mostLeftLi.getAttribute('data-season');
                    if(season != this.season){
                        document.body.setAttribute('data-season', season);
                        this.season = season;
                    }
                }
            });
        });
        
        this._loadDiscographyHTML(this.thumblist_items[0].getAttribute('data-id'), document.querySelector('.storybox.-story1'));
    }


    _change(key, season, title){
        const $tempstory = document.querySelector(`.storybox.-${key}`);

        // 前回初期化
        if(this.$storybox){
            document.querySelector(`.thumblist__item[data-key=${this.current}]`).classList.remove('-current');
            this.$storybox.querySelector('.storybox__season__sholder').classList.remove('-change');
            this.$storybox.querySelector('.storybox__season__title').classList.remove('-change');
            this.$storybox.classList.remove('-current');
        }

        // カレント
        const current_thumb = document.querySelector(`.thumblist__item[data-key=${key}]`);
        current_thumb.classList.add('-current');
        $tempstory.classList.add('-current');

        // 変更
        if(this.season!=season){
            document.body.setAttribute('data-season', season);
            $tempstory.querySelector('.storybox__season__sholder').classList.add('-change');
        }
        if(this.title!=title){
            $tempstory.querySelector('.storybox__season__title').classList.add('-change');
        }

        // 購入リンク
        this._loadDiscographyHTML(current_thumb.getAttribute('data-id'), $tempstory);

        this.$storybox = $tempstory;
        this.current = key;
        this.season = season;
        this.title = title;
    }


    _loadDiscographyHTML(idStr, $storybox) {
        const ids = idStr.split(',');
    
        // 各idに対する非同期処理の配列を作成
        const promises = ids.map(id => {
            const url = `/discography/detail.php?id=${id}`;
    
            return fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.text();
                })
                .then(html => {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(html, 'text/html');
                    let linkElement = doc.querySelector('.discography_single__cont__buy');
    
                    if(linkElement){
                        let urlString = linkElement.getAttribute('href');
                        let idPart = urlString.split('?id=')[1];
                        return `/discography/shop_modal.php?id=${idPart}`; 
                    } else {
                        //console.log('The element was not found for id: ' + id);
                        return null;
                    }
                });
        });
    
        Promise.all(promises)
            .then(urls => {
                const links = [...$storybox.querySelectorAll('.js-btnBuy a')];
    
                urls.forEach((url, index) => {
                    if(url && links[index]) links[index].setAttribute('href', url);
                });
            })
            .catch(error => {
                //console.log('Fetch error: ' + error.message);
            });
    }
    
}